import { styled } from '@mui/material';

import { Box, BoxProps } from './Box';

const Flex = styled(Box)``;
Flex.defaultProps = { display: 'flex' };

export { Flex };
export type { BoxProps as FlexProps };
